import BaseAPI from './base/base-api';

class StateBudgetAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'ManagementAPI';
    controllerName = 'StateBudget';
}

export default new StateBudgetAPI();